<template>
    <div id="app">
        <!-- <component :is="layout.name" v-if="layout.type"/> -->
        <div class="container">
            <router-view/>
        </div>
    </div>
</template>

<script>
    import LayoutComponent from './components/layout/LayoutComponent';

    export default {
        name: 'App',

        data(){
            return {
                layout:{
                    type: false,
                    name: 'layout-component'
                }
            }
        },

        watch:{
            '$route':function(to){
                if(typeof to.meta.layout === "undefined" || to.meta.layout === true){
                    this.layout.type = true;
                    this.layout.name = 'layout-component';
                }
                else if(typeof to.meta.layout === "string"){
                    this.layout.type = true;
                    this.layout.name = to.meta.layout;
                }
                else if(to.meta.layout === false){
                    this.layout.type = false;
                }
            }
        },
        mounted() {
            let that = this;
            let layer = window.layer;
            // 添加返回事件监听
            window.addEventListener("popstate", function(e) {
                var url = window.location.href;
                if( !url.split("#")[1]){
                    layer.closeAll()
                    let dv = document.querySelectorAll(".layui-layer-shade")
                    let dv1 = document.querySelectorAll(".layui-layer-move")
                    if(dv[0]){
                        dv[0].remove()
                    }
                     if(dv1[0]){
                        dv1[0].remove()
                    }
                }
                if(url.split("/Warp")[1] == ''){
                    history.back(-1);
                }
            }, false);
        },
        components:{
            LayoutComponent
        }
    }
</script>

<style lang="less">
    @import "./assets/css/style";
    *{box-sizing: border-box}
    #app{
        position: relative;
        width: 100%;
    }
    .base_btn{
        width:120px;
        height:32px;
        background:@btn-color-blue;
        border-radius:4px;
        font-size:16px;
        color:#FFFFFF;
        text-align: center;
        line-height: 32px;
        cursor: pointer;
        margin-right:10px;
    }
	.btn-primary{
		background-color: @btn-color-blue;
		color:@position-color;
    }
    .btn-yellow{
        background-color:@btn-color-yellow;
		color:@position-color;
    }
    .ivu-modal{
        top:350px;
        .ivu-modal-body{
            padding:30px
        };
        img{
            width: 55px;
        };
        .newImg{
            color: red
        }
    }
    #id-modal{
        .ivu-modal{
            top: 350px;
        }
    }
    #id-modalOrg{
        .ivu-modal{
            top: 350px;
        }
    }
    #id-modalOrg3{
        .ivu-modal{
            top: 350px;
        }
    }
     @media screen and (max-height: 680px) {
       #id-modal,#id-modal2,#id-modal3{
            .ivu-modal{
                top: 260px;
            }
        }
        #id-modalOrg{
            .ivu-modal{
                top: 260px;
            }
        }
    }
    .ivu-form-item-error-tip{
        position:inherit
    }
    .ivu-input{
        z-index: 50;
    }
    ///图片上传样式
    .myImg{
        text-align: center;
        height: 185px;
    }
    // 表格
    .myTable{
        width: 100%;
        border-spacing: 0;
        border-collapse: collapse;
        th{
            background: #E6E6E6;
            height:35px;
            border:1px solid #CCCCCC;
        }
        tr{
            text-align: center;
            height:30px;
            border:1px solid #CCCCCC;
        }
        td{
            border:1px solid #CCCCCC;

        }
    }
    // 列表页分割
    .segmentation{
        height:10px;
        background:#ECEEF2;
    }
    // 取消进度条多于样式
    .ivu-upload-list:first-of-type(1){
        display: none !important;
    }
    .ivu-upload-list-file{

        span{
            display: none !important;
        }
        
    }
    #name{
        // .ivu-spin-fix{
            z-index: 10000;
            background-color: rgba(255, 255, 255, 0);
        // }
    }
    // .ivu-spin-fix{
    //     z-index: 10000;
    //     background-color: rgba(255, 255, 255, 0);

    // }
    .demo-spin-icon-load{
        animation: ani-demo-spin 1s linear infinite;
    }
    @keyframes ani-demo-spin {
        from { transform: rotate(0deg);}
        50%  { transform: rotate(180deg);}
        to   { transform: rotate(360deg);}
    }
    .demo-spin-col{
        height: 100px;
        position: relative;
        border: 1px solid #eee;
    }
</style>
<style>
    .layui-layer-title {
        padding: 0 80px !important;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue